<template>
  <div class="key-filter-fields">
    <label class="form-label">Регион</label>
    <RegionSelect v-model="form.regions" placeholder="Выберите страну или округ" />

    <div class="mb-3">
      <label class="form-label d-block">Тип закупки</label>
      <div class="form-check form-check-inline" v-for="opt in TYPE_FLAGS_RU" :key="opt.key">
        <input
          class="form-check-input"
          type="checkbox"
          :id="idPrefix + 'type-' + opt.key"
          v-model="form.flags[opt.key]"
          :disabled="disabled"
        />
        <label class="form-check-label" :for="idPrefix + 'type-' + opt.key">{{ opt.label }}</label>
      </div>
      <div v-if="showKz" class="w-100" />
      <div v-if="showKz" class="mt-2">
        <div class="form-check form-check-inline" v-for="opt in TYPE_FLAGS_KZ" :key="opt.key">
          <input
            class="form-check-input"
            type="checkbox"
            :id="idPrefix + 'type-' + opt.key"
            v-model="form.flags[opt.key]"
            :disabled="disabled"
          />
          <label class="form-check-label" :for="idPrefix + 'type-' + opt.key">{{ opt.label }}</label>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <label class="form-label">Мин. цена</label>
        <input
          v-model="form.minPrice"
          type="number"
          min="0"
          placeholder="0"
          class="form-control form-control-sm"
          :disabled="disabled"
        />
      </div>
      <div class="col">
        <label class="form-label">Макс. цена</label>
        <input
          v-model="form.maxPrice"
          type="number"
          min="0"
          placeholder="0"
          class="form-control form-control-sm"
          :disabled="disabled"
        />
      </div>
      <div class="col">
        <label class="form-label">% аванса</label>
        <input
          v-model="form.prepayment"
          type="number"
          min="0"
          placeholder="0"
          class="form-control form-control-sm"
          :disabled="disabled"
        />
      </div>
    </div>

    <div class="row g-2 align-items-end">
      <div class="col-auto">
        <RadioTriple v-model="form.guaranteeApp" label="Обеспечение заявки" />
      </div>
      <div class="col-2" v-if="form.guaranteeApp === 'yes'">
        <label class="form-label small">До</label>
        <input
          v-model.number="form.guaranteeAppMax"
          type="number"
          min="0"
          class="form-control form-control-sm"
          placeholder="0"
          :disabled="disabled"
        />
      </div>
    </div>

    <div class="row g-2 align-items-end">
      <div class="col-auto">
        <RadioTriple v-model="form.guaranteeContract" label="Обеспечение контракта" />
      </div>
      <div class="col-2" v-if="form.guaranteeContract === 'yes'">
        <label class="form-label small">До</label>
        <input
          v-model.number="form.guaranteeContractMax"
          type="number"
          min="0"
          class="form-control form-control-sm"
          placeholder="0"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import RegionSelect from '@/components/RegionSelect.vue'
import RadioTriple from '@/components/RadioTriple.vue'
import { TYPE_FLAGS_RU, TYPE_FLAGS_KZ } from '@/constants/keyFilterTypes'

const props = defineProps({
  modelValue: { type: Object, required: true },
  idPrefix: { type: String, default: '' },
  showKz: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
})

const form = computed(() => props.modelValue)
</script>
